/**
 * Udělá překlad textu podle zadaného počtu
 * @param text tvary textu oddělené znakem `|` (pipe) pro `1, 2-4, 5+` nebo `0, 1, 2-4, 5+`
 * @param count počet pro který se má text přeložit
 * @param withNumber přidat číslo před text `default: true`
 */
export const pluralTranslate = (text: string, count: number, withNumber: boolean = true) => {
    const parts = text.split('|')
    // kontrola zda se v textu nachází potřebné tvary
    if (parts.length !== 3 && parts.length !== 4) {
        console.warn(`Daný text "${text}" nemá správný formát`)
        return withNumber ? `${count} ${text}` : text
    }

    // rozdělení textu na jednotlivé tvary
    // eslint-disable-next-line perfectionist/sort-variable-declarations
    let zero: string, one: string, two: string, five: string
    if (parts.length === 3) {
        [one, two, five] = parts.map(t => t.trim())
        // 0 a 5 a více je stejné, ale kdyby náhodou, je možnost ho tam přidat jako první
        zero = five
    } else {
        [zero, one, two, five] = parts.map(t => t.trim())
    }

    let output: string = five
    if (count === 0) {
        output = zero // 0 jablek
    }
    if (count === 1) {
        output = one // 1 jablko
    }
    if (count >= 2 && count <= 4) {
        output = two // 2 jablka, 3 jablka, 4 jablka
    }
    // 5 jablek, 120 jablek, nekonečno jablek
    return withNumber ? `${count} ${output}` : output
}

/**
 * Convert m2 to m² and m3 to m³
 * @param text
 */
export const unitConvert = (text: string) => text.replaceAll('m2', 'm²').replaceAll('m3', 'm³')
